"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.VersionType=void 0;var o;(function(r){r.Control="control",r.IndividualProduct="individual_product",r.NoRatingorder="no_ratingorder",r.Order="order",r.Product="product"})(o||(exports.VersionType=o={}));
//# sourceMappingURL=VersionType.js.map
